import $ from 'jquery';
export default class dealerModals {
  static openDealerModal(modalName) {
    const modal = document.querySelectorAll(`[data-modal="${modalName}"]`);

    $('body').addClass('modal-open');
    $(modal).fadeIn('fast').addClass('active');
  }

  static closeDealerModal(modalName) {
    const modal = document.querySelectorAll(`[data-modal="${modalName}"]`);

    $('body').removeClass('modal-open');
    $(modal).fadeOut('fast').removeClass('active');
  }
}
